var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 70,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4AB73",
    d: "M78 8.517v46.666c0 3.807-3.075 7.3-6.85 7.77l-1.206.158c-6.383.863-15.373 3.532-22.612 6.593-2.53 1.06-5.332-.863-5.332-3.65V11.46c0-1.452.817-2.786 2.102-3.493C51.224 4.082 62.004.628 69.322 0h.233C74.225 0 78 3.807 78 8.517ZM33.937 7.967C26.815 4.082 16.035.628 8.717 0h-.272C3.775 0 0 3.807 0 8.517v46.666c0 3.807 3.075 7.3 6.85 7.77l1.206.158c6.383.863 15.373 3.532 22.612 6.593 2.53 1.06 5.332-.863 5.332-3.65V11.46a3.927 3.927 0 0 0-2.063-3.493ZM11.715 19.86h8.756c1.596 0 2.92 1.334 2.92 2.943a2.927 2.927 0 0 1-2.92 2.944h-8.756a2.927 2.927 0 0 1-2.92-2.944c0-1.61 1.324-2.944 2.92-2.944ZM23.39 37.52H11.715a2.927 2.927 0 0 1-2.92-2.944c0-1.609 1.324-2.943 2.92-2.943H23.39c1.596 0 2.92 1.334 2.92 2.944a2.927 2.927 0 0 1-2.92 2.943Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy1);
export default __webpack_public_path__ + "static/media/why_1.ea5524297746afbfdb4f63fc106c1120.svg";
export { ForwardRef as ReactComponent };